import module from '../module';
import scopeUtils from "../../../utils/scope";

export class MessageService {
    static $inject = [ '$mdToast', '$mdDialog', "$rootScope" ];

    constructor(toastService, dialogService, rootScope) {
        this._toastService = toastService;
        this._dialogService = dialogService;
        this._rootScope = rootScope;
    }

    _showMessagePopup(messageText, isError, title,buttonText = 'Close') {
        let self = this;
        return new Promise(resolve => {
            self._rootScope.headerMessage = {
                resolve: resolve,
                content: messageText,
                class: isError ? 'danger' : 'success'
            };
            scopeUtils.apply(self._rootScope);
        });
        // return this._dialogService.show({
        //     controller: [ '$scope', '$mdDialog', ($scope, $mdDialog) => {
        //         $scope.close = () => $mdDialog.hide();
        //         $scope.title = title;
        //         $scope.message = messageText;
        //         $scope.isError = isError;
        //         $scope.buttonText = buttonText;
        //     } ],
        //     templateUrl: 'modules/shared/views/messageDialog.html',
        //     escapeToClose: true,
        //     clickOutsideToClose: true
        // });
    }
 
    showLoading() {
        return new Promise((resolve, reject) => {
            this._dialogService.show({
                controller: [ '$scope', '$mdDialog', ($scope, $mdDialog) => {
                    $scope.close = () => $mdDialog.hide();
                    resolve($scope);
                } ],
                template: require('../views/loadingDialog.pug'),
                escapeToClose: true,
                clickOutsideToClose: false
            });
        });
    }
    showLoadingWhiteBackground() {
        return new Promise((resolve, reject) => {
            this._dialogService.show({
                controller: [ '$scope', '$mdDialog', ($scope, $mdDialog) => {
                    $scope.close = () => $mdDialog.hide();
                    resolve($scope);
                } ],
                template: require('../views/loadingDialogWhitebackground.pug'),
                escapeToClose: true,
                clickOutsideToClose: false
            });
        });
    }

    showErrorPopup(messageText) {
        return this._showMessagePopup(messageText, true);
    }

    showMessagePopup(messageText, buttonText) {
        return this._showMessagePopup(messageText, false,'',buttonText);
    }

    showAlertPopup(messageText, buttonText) {
      return this._dialogService.show({
        controller: [ '$scope', '$mdDialog', ($scope, $mdDialog) => {
          $scope.close = () => $mdDialog.hide();
          $scope.title = '';
          $scope.message = messageText;
          $scope.buttonText = buttonText;
        } ],
        templateUrl: 'modules/shared/views/messageDialog.html',
        escapeToClose: true,
        clickOutsideToClose: true,
        multiple: true,
        hasBackdrop: true
      });
    }

    showQuestionPopup(messageText, title = '', yesBtnText = 'Yes', noBtnText = 'No', yesBtnClass = 'primary', noBtnClass = 'secondary') {
        return this._dialogService.show({
            controller: [ '$scope', '$mdDialog', ($scope, $mdDialog) => {
                $scope.close = (response) => {
                    $mdDialog.hide(response);
                };

                $scope.cancel = () => {
                    $mdDialog.hide(false);
                };

                $scope.title = title;
                $scope.message = messageText;
                $scope.yesBtnText = yesBtnText;
                $scope.yesBtnClass = yesBtnClass;
                $scope.noBtnText = noBtnText;
                $scope.noBtnClass = noBtnClass;
            } ],
            templateUrl: 'modules/shared/views/questionDialog.html',
            escapeToClose: true,
            clickOutsideToClose: false
        });
    }

    getMessageFromErrorResponse(response) {
        return response && response.data && response.data.message;
    }

    isErrorResponse(response) {
        return response && response.status >= 400;
    }

    showErrorPopupForResponse(errorResponse) {
        const message = this.getMessageFromErrorResponse(errorResponse);
        return this.showErrorPopup(message || (errorResponse && errorResponse.statusText) || "Unknown error occurred: " + JSON.stringify(errorResponse));
    }
}

module.service('Message', MessageService);



// WEBPACK FOOTER //
// ./src/modules/shared/services/MessageService.js